
import { useEffect, useState } from 'react';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-[1440px] mx-auto px-20 h-[72px] flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src="https://public.readdy.ai/ai/img_res/13239f7c-c91a-4371-8f45-672cc168d73b.png" alt="OPAL d.o.o. Logo" className="h-10 w-10 object-contain" />
            <span className="text-[16px] font-light tracking-wider uppercase text-[#0A1628]">OPAL d.o.o.</span>
          </div>
          <div className="flex gap-12">
            <a href="#about" className="text-[15px] text-[#0A1628] hover:text-[#FF6B4A] transition-colors cursor-pointer">About</a>
            <a href="#products" className="text-[15px] text-[#0A1628] hover:text-[#FF6B4A] transition-colors cursor-pointer">Products</a>
            <a href="#contact" className="text-[15px] text-[#0A1628] hover:text-[#FF6B4A] transition-colors cursor-pointer">Contact</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-[160px] pb-[120px] bg-gradient-to-b from-white to-[#F5F7FA]">
        <div className="max-w-[1440px] mx-auto px-20">
          <div className="flex items-center gap-16">
            <div className="w-[45%]">
              <h1 className="text-[72px] leading-[1.1] font-serif tracking-tight text-[#0A1628] mb-12">
                Elevating iOS Experience
              </h1>
              <p className="text-[18px] text-gray-600 leading-relaxed">
                Expert team crafting VPN and Cleaner solutions for enhanced mobile security and performance
              </p>
            </div>
            <div className="w-[55%]">
              <div className="rounded-[32px] overflow-hidden shadow-[0_24px_48px_rgba(0,0,0,0.08)]">
                <img 
                  src="https://public.readdy.ai/ai/img_res/c3a936e164ab41c3a87c418da6f0a671.jpg" 
                  alt="iOS App Development" 
                  className="w-full h-[600px] object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-[160px] bg-white">
        <div className="max-w-[1440px] mx-auto px-20">
          <div className="flex items-center gap-16">
            <div className="w-1/2">
              <div className="rounded-[40px] overflow-hidden relative shadow-[0_24px_48px_rgba(0,0,0,0.08)]">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20modern%20tech%20workspace%20with%20developers%20working%20on%20iOS%20applications%20showing%20MacBooks%20and%20iPhones%20in%20bright%20contemporary%20office%20environment%20with%20minimalist%20design%20clean%20aesthetic%20natural%20lighting%20and%20collaborative%20atmosphere%20representing%20innovation%20and%20expertise&width=700&height=800&seq=about001&orientation=portrait" 
                  alt="OPAL Team" 
                  className="w-full h-[800px] object-cover object-top"
                />
                <div className="absolute top-8 left-8 flex gap-3">
                  <span className="px-6 py-3 bg-white/80 backdrop-blur-md rounded-full text-[14px] font-medium text-[#0A1628]">iOS Experts</span>
                  <span className="px-6 py-3 bg-white/80 backdrop-blur-md rounded-full text-[14px] font-medium text-[#0A1628]">Est. 2020</span>
                  <span className="px-6 py-3 bg-white/80 backdrop-blur-md rounded-full text-[14px] font-medium text-[#0A1628]">Croatia Based</span>
                </div>
              </div>
            </div>
            <div className="w-1/2">
              <h2 className="text-[64px] leading-[1.1] font-serif text-[#0A1628] mb-8">OPAL d.o.o.</h2>
              <div className="flex gap-4 mb-16">
                <span className="px-5 py-2 border-2 border-[#0A1628] rounded-full text-[14px] font-medium text-[#0A1628]">Development</span>
                <span className="px-5 py-2 text-[14px] font-medium text-gray-600">Innovation</span>
                <span className="px-5 py-2 text-[14px] font-medium text-gray-600">Quality</span>
              </div>
              <div className="bg-[#0A1628] rounded-[24px] p-12 relative overflow-hidden">
                <span className="inline-block px-4 py-2 bg-[#FF6B4A] rounded-full text-[12px] font-semibold text-white mb-6">Our Mission</span>
                <h3 className="text-[32px] font-serif text-white mb-6">Building Tomorrow's Mobile Solutions</h3>
                <p className="text-[16px] text-gray-300 leading-relaxed mb-8">
                  OPAL d.o.o. is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices. We combine cutting-edge technology with intuitive design to deliver solutions that millions of users trust daily.
                </p>
                <div className="rounded-[16px] overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=sleek%20modern%20iOS%20mobile%20app%20interface%20mockup%20showing%20VPN%20and%20cleaner%20applications%20on%20iPhone%20screens%20with%20dark%20elegant%20UI%20design%20featuring%20security%20icons%20and%20optimization%20graphics%20in%20minimalist%20style%20with%20gradient%20accents&width=500&height=300&seq=mission001&orientation=landscape" 
                    alt="App Interfaces" 
                    className="w-full h-[300px] object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-[160px] bg-[#F5F7FA]">
        <div className="max-w-[1440px] mx-auto px-20">
          <div className="text-center mb-[120px]">
            <div className="inline-flex items-center gap-2 mb-6">
              <i className="ri-apps-line text-[#FF6B4A] text-[20px]"></i>
              <span className="text-[14px] font-semibold text-[#FF6B4A] uppercase tracking-wider">Our Products</span>
            </div>
            <h2 className="text-[56px] font-serif text-[#0A1628]">Designed for Modern iOS Users</h2>
          </div>

          <div className="grid grid-cols-12 gap-8">
            {/* VPN Product - Tall Card */}
            <div className="col-span-4 row-span-2">
              <div className="bg-[#0A1628] rounded-[24px] p-12 h-full flex flex-col justify-between shadow-[0_8px_32px_rgba(0,0,0,0.06)]">
                <div>
                  <div className="w-[48px] h-[48px] bg-white rounded-full flex items-center justify-center mb-8">
                    <i className="ri-shield-keyhole-line text-[#0A1628] text-[24px]"></i>
                  </div>
                  <h3 className="text-[42px] font-serif text-white mb-6">Secure VPN</h3>
                  <p className="text-[16px] text-gray-300 leading-relaxed mb-8">
                    Protect your online privacy with our advanced VPN solution. Browse securely, access content globally, and keep your data safe from prying eyes with military-grade encryption.
                  </p>
                </div>
                <div className="pt-8 border-t border-white/20">
                  <p className="text-[14px] text-gray-400">Military-grade encryption</p>
                </div>
              </div>
            </div>

            {/* VPN Interface - Square Card */}
            <div className="col-span-4">
              <div className="rounded-[24px] overflow-hidden relative h-[400px] shadow-[0_8px_32px_rgba(0,0,0,0.06)]">
                <img 
                  src="https://readdy.ai/api/search-image?query=modern%20VPN%20mobile%20app%20interface%20screenshot%20on%20iPhone%20showing%20connection%20status%20with%20elegant%20dark%20blue%20UI%20design%20featuring%20security%20shield%20icon%20location%20selector%20and%20connect%20button%20in%20minimalist%20professional%20style%20with%20gradient%20background&width=500&height=500&seq=vpn001&orientation=squarish" 
                  alt="VPN Interface" 
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-8 left-8">
                  <div className="flex items-center gap-2 mb-3">
                    <i className="ri-shield-check-line text-white text-[20px]"></i>
                    <span className="text-[14px] font-semibold text-white">Security</span>
                  </div>
                </div>
                <div className="absolute bottom-8 left-8">
                  <h4 className="text-[28px] font-serif text-white">Privacy First</h4>
                </div>
              </div>
            </div>

            {/* Cleaner Product - Wide Card */}
            <div className="col-span-4 row-span-2">
              <div className="bg-white rounded-[24px] p-12 h-full flex flex-col justify-between shadow-[0_8px_32px_rgba(0,0,0,0.06)] border-l-4 border-[#FF6B4A]">
                <div>
                  <h3 className="text-[42px] font-serif text-[#0A1628] mb-6">Smart Cleaner</h3>
                  <p className="text-[16px] text-gray-600 leading-relaxed mb-8">
                    Optimize your device performance with intelligent storage management. Remove junk files, duplicate photos, and unnecessary data to keep your iPhone running smoothly and efficiently.
                  </p>
                </div>
                <div className="rounded-[16px] overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20interface%20on%20iPhone%20displaying%20storage%20optimization%20features%20with%20clean%20white%20UI%20showing%20storage%20usage%20charts%20file%20categories%20and%20cleaning%20options%20in%20modern%20minimalist%20design%20with%20coral%20orange%20accent%20colors&width=500&height=400&seq=cleaner001&orientation=landscape" 
                    alt="Cleaner Interface" 
                    className="w-full h-[400px] object-cover object-top"
                  />
                </div>
              </div>
            </div>

            {/* Feature Highlight */}
            <div className="col-span-4">
              <div className="bg-white rounded-[24px] p-10 h-[400px] flex flex-col justify-center shadow-[0_8px_32px_rgba(0,0,0,0.06)]">
                <i className="ri-speed-up-line text-[#FF6B4A] text-[48px] mb-6"></i>
                <h4 className="text-[28px] font-serif text-[#0A1628] mb-4">Performance Boost</h4>
                <p className="text-[15px] text-gray-600 leading-relaxed">
                  Experience faster app launches and smoother multitasking with optimized device performance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-[160px] bg-white">
        <div className="max-w-[1440px] mx-auto px-20">
          <div className="text-center mb-[80px]">
            <h2 className="text-[56px] font-serif text-[#0A1628] mb-6">Get in Touch</h2>
            <p className="text-[18px] text-gray-600">We're here to help and answer any questions you might have</p>
          </div>

          <div className="grid grid-cols-3 gap-12">
            {/* Location */}
            <div className="bg-[#F5F7FA] rounded-[24px] p-10">
              <div className="w-[56px] h-[56px] bg-[#FF6B4A] rounded-full flex items-center justify-center mb-6">
                <i className="ri-map-pin-line text-white text-[28px]"></i>
              </div>
              <h3 className="text-[24px] font-semibold text-[#0A1628] mb-4">Location</h3>
              <p className="text-[15px] text-gray-600 leading-relaxed">
                Trg svetog Josipa 1<br />
                City Slatina<br />
                Zip 33520<br />
                Country Croatia
              </p>
            </div>

            {/* Email */}
            <div className="bg-[#F5F7FA] rounded-[24px] p-10">
              <div className="w-[56px] h-[56px] bg-[#FF6B4A] rounded-full flex items-center justify-center mb-6">
                <i className="ri-mail-line text-white text-[28px]"></i>
              </div>
              <h3 className="text-[24px] font-semibold text-[#0A1628] mb-4">Email</h3>
              <p className="text-[15px] text-gray-600 leading-relaxed">
                help@opaldoo.com
              </p>
            </div>

            {/* Phone */}
            <div className="bg-[#F5F7FA] rounded-[24px] p-10">
              <div className="w-[56px] h-[56px] bg-[#FF6B4A] rounded-full flex items-center justify-center mb-6">
                <i className="ri-phone-line text-white text-[28px]"></i>
              </div>
              <h3 className="text-[24px] font-semibold text-[#0A1628] mb-4">Number</h3>
              <p className="text-[15px] text-gray-600 leading-relaxed">
                +1 7813325179
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A1628] py-20 mx-20 mb-20 rounded-[40px]">
        <div className="max-w-[1440px] mx-auto px-20">
          <div className="grid grid-cols-12 gap-16 mb-16">
            {/* Company Info */}
            <div className="col-span-5">
              <div className="flex items-center gap-4 mb-6">
                <img src="https://public.readdy.ai/ai/img_res/13239f7c-c91a-4371-8f45-672cc168d73b.png" alt="OPAL d.o.o. Logo" className="h-12 w-12 object-contain" />
                <h3 className="text-[48px] font-serif font-light text-white">OPAL d.o.o.</h3>
              </div>
              <p className="text-[16px] text-gray-400 leading-relaxed">
                Developing innovative iOS applications since 2020. Trusted by millions of users worldwide for security and performance.
              </p>
            </div>

            {/* Quick Links */}
            <div className="col-span-3">
              <h4 className="text-[18px] font-semibold text-white mb-6">Explore</h4>
              <ul className="space-y-4">
                <li><a href="#products" className="text-[15px] text-gray-400 hover:text-white transition-colors cursor-pointer">Products</a></li>
                <li><a href="#about" className="text-[15px] text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</a></li>
                <li><a href="#contact" className="text-[15px] text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="col-span-4">
              <h4 className="text-[18px] font-semibold text-white mb-6">Contact</h4>
              <div className="space-y-3 mb-8">
                <p className="text-[15px] text-gray-400">+1 7813325179</p>
                <p className="text-[15px] text-gray-400">help@opaldoo.com</p>
              </div>
              <h4 className="text-[18px] font-semibold text-white mb-6">Location</h4>
              <div className="space-y-2">
                <p className="text-[15px] text-gray-400">Trg svetog Josipa 1</p>
                <p className="text-[15px] text-gray-400">Slatina, 33520</p>
                <p className="text-[15px] text-gray-400">Croatia</p>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-white/10 flex items-center justify-between">
            <p className="text-[14px] text-gray-500">© 2025 OPAL d.o.o. All rights reserved</p>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[14px] text-gray-500 hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
